import { MemberDTO } from "../../services/apiClient";
import { convertToUserTime } from "../../utils/dateUtils/convertToUserTime";
import { MemberTypeConstants } from "../../constants/MemberTypeConstants";

export default function MembershipStatusOverview({
    member
}: {
    member: MemberDTO | null
}) {
    if (!member) return null;

    // Check if member is a life member
    const isLifeMember = member.memberTypeId && (
        member.memberTypeId.toLowerCase() === MemberTypeConstants.LIFE_MEMBER.toLowerCase() ||
        member.memberTypeId.toLowerCase() === MemberTypeConstants.DEDICATED_LIFE_MEMBER.toLowerCase()
    );

    // Determine if membership is paid up (life members are always paid up)
    const isPaidUp = isLifeMember || (member.paidUpTo ? new Date(member.paidUpTo) > new Date() : false);

    // Format dates
    const formatDate = (date: Date | string | null | undefined): string => {
        if (!date) return "-";
        try {
            return convertToUserTime(String(date), true);
        } catch {
            return "-";
        }
    };

    // Get paid-up value (show "Life Member" for life members, otherwise show date)
    const getPaidUpValue = (): string => {
        if (isLifeMember) return "Life Member";
        return formatDate(member.paidUpTo);
    };

    return (
        <div className="rounded-2xl bg-white p-4 shadow">
            <div className="mb-3 flex items-center justify-between">
                <h3 className="text-sm font-semibold">MEMBERSHIP STATUS</h3>
                <span className={`rounded-full border px-2 py-0.5 text-xs ${isPaidUp
                        ? 'text-green-600 border-green-600'
                        : 'text-red-600 border-red-600'
                    }`}>
                    {isPaidUp ? 'Paid-up' : 'Outstanding'}
                </span>
            </div>
            <div className="grid grid-cols-2 gap-3">
                <StatBox
                    label="PAID-UP TILL"
                    value={getPaidUpValue()}
                    color={isPaidUp ? "text-green-600" : "text-red-600"}
                />
                <StatBox
                    label="DATE ENROLLED"
                    value={formatDate(member.dateEnrolled)}
                    color="text-gray-600"
                />
            </div>
        </div>
    );
}

function StatBox({ label, value, color }: { label: string; value: string; color: string }) {
    return (
        <div className="rounded-lg bg-gray-50 p-4 text-center">
            <div className={`text-xl font-bold ${color}`}>{value}</div>
            <div className="text-xs text-gray-600">{label}</div>
        </div>
    );
}
